import { Component,OnInit,OnDestroy,AfterViewInit,ChangeDetectionStrategy,Pipe,PipeTransform,Input } from '@angular/core';

import { NgbModal,NgbActiveModal,ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { Subject } from 'rxjs';
import { NoticeDetailPopupComponent } from "src/app/fvms/notice/detail.popup/notice.detail.popup.component";
import { FvmsApiNoticeService } from "src/app/shared/service/fvms.api.notice.service";
import {
    PagingInfo
    ,FvmsNoticeInfo
    ,DtgListType
} from "src/app/shared/vo";

@Component({
    selector: "notice-list-popup"
    ,styleUrls: ["./notice.list.popup.component.scss"]
    ,templateUrl: "./notice.list.popup.component.html"
})

export class NoticeListPopupComponent implements OnInit,OnDestroy {
    isContinue:boolean = true;
    listNotice:any[] = [];
    pagingInfo:PagingInfo = new PagingInfo();
    fvmsNoticeInfo:FvmsNoticeInfo = new FvmsNoticeInfo();
    DtgListType = DtgListType;
    
    constructor(
        public activeModal: NgbActiveModal
        ,private fvmsApiNoticeService:FvmsApiNoticeService
        ,private modalService: NgbModal
    ) {
        
    } 

    @Input()
    set inputNoticeItem(noticeTarget:any){
        if(noticeTarget){
            this.fvmsNoticeInfo.noticeTarget = noticeTarget;
        }
    }
 

    ngOnInit() {
        this.reloadNoticeList();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    


    clickCancel(){
        this.activeModal.close({
            "type":"cancel"
        });
    }

    reloadNoticeList(){
        this.pagingInfo.curPage=1;
        this.getNoticeList();
    }

    getNoticeList(){
        this.fvmsApiNoticeService.getListNotice(this.fvmsNoticeInfo,this.pagingInfo)
        .pipe(takeWhile(() => this.isContinue))
        .subscribe(apiResponse => {    
            this.listNotice = apiResponse.resultValue;
            this.pagingInfo = apiResponse.pagingInfo;
        });
    }
    clickNoticeDetailModal(noticeItem){
        let modalRef = this.modalService.open(
            NoticeDetailPopupComponent
            ,{
                centered:true
                //,size: "lg"
                ,size: "xl"
                //,backdrop:"static"
                //windowClass: 'dark-modal'
                ,scrollable: true
            }
        );

        modalRef.componentInstance.inputNoticeItem = noticeItem;

        modalRef.result.then((resultModal) => {
            if(resultModal.type === "ok"){
              
            }
        });
        noticeItem.viewCnt++;
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.getNoticeList();
    }
    
    
    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

}